import { createSlice } from "@reduxjs/toolkit";
import { getOrderDetails, orderList } from "./orderThunk";

const initialState = () => ({
  orderLoading: false,
  orderData: [],
  orderCount: 0,
  orderDetails: {},
});

const orderSlice = createSlice({
  initialState: initialState(),
  name: "order",
  reducers: {},
  extraReducers: (builder) => {
    //get All Orders List
    builder
      .addCase(orderList.pending, (state, { payload }) => {
        state.orderLoading = true;
      })
      .addCase(orderList.fulfilled, (state, { payload }) => {
        state.orderLoading = false;
        state.orderData = payload?.data?.rows;
        state.orderCount = payload?.data?.count;
      })
      .addCase(orderList.rejected, (state, { payload }) => {
        state.orderLoading = false;
      });
    //get All Orders List
    builder
      .addCase(getOrderDetails.pending, (state, { payload }) => {
        state.orderLoading = false;
      })
      .addCase(getOrderDetails.fulfilled, (state, { payload }) => {
        state.orderLoading = false;
        state.orderDetails = payload?.data;
      })
      .addCase(getOrderDetails.rejected, (state, { payload }) => {
        state.orderLoading = false;
      });
  },
});
// eslint-disable-next-line no-empty-pattern
export const {} = orderSlice.actions;
export default orderSlice.reducer;
